import { render, staticRenderFns } from "./OrderEditDetail.vue?vue&type=template&id=0bb37c9d"
import script from "./OrderEditDetail.vue?vue&type=script&lang=js"
export * from "./OrderEditDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderEditDetail.vue?vue&type=style&index=0&id=0bb37c9d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports